import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { StaffPage } from '@/features/staff/pages/StaffPage'

const searchSchema = z.object({
  tab: z.enum(['staff', 'leave', 'loans']).catch('staff'),
})

export const Route = createFileRoute('/_app/staff/')({
  validateSearch: searchSchema,
  component: StaffPage,
})
